import { useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';
import { UserPlus } from 'lucide-react';
import PageHero from '@/components/PageHero';

export default function Submit() {
  const [form, setForm] = useState({
    type: 'leader',
    name: '',
    role: '',
    church: '',
    district: '',
    department: '',
    submitter_email: '',
    submitter_phone: '',
    photo_url: '',
    notes: '',
  });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/site/submissions', form);
      toast.success('Submitted! An administrator will review your request.');
      setForm({ ...form, name: '', role: '', church: '', district: '', department: '', notes: '' });
    } catch { toast.error('Could not submit.'); }
  };
  return (
    <div>
      <PageHero slug="submit" overline="Claim / Submit Info" heading="Submit an Update" text="Pastors, department leaders, district officers, and members: use this form to submit or update information about yourself, your church, district, or department. All submissions are reviewed by a jurisdictional administrator." />
      <section className="bg-white py-20">
        <form onSubmit={submit} className="max-w-2xl mx-auto px-6 card-tactile p-8 space-y-4">
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Type of submission">
              <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} className="w-full px-3 py-2 border rounded">
                <option value="leader">Leader profile (self / others)</option>
                <option value="church">Church info</option>
                <option value="district">District info</option>
                <option value="department">Department info</option>
                <option value="event">Event announcement</option>
                <option value="correction">Correction / other</option>
              </select>
            </Field>
            <Field label="Your email"><input required type="email" value={form.submitter_email} onChange={e => setForm({ ...form, submitter_email: e.target.value })} className="w-full px-3 py-2 border rounded" /></Field>
          </div>
          <Field label="Name / Title of subject"><input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full px-3 py-2 border rounded" /></Field>
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Position / Role"><input value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} className="w-full px-3 py-2 border rounded" /></Field>
            <Field label="Church"><input value={form.church} onChange={e => setForm({ ...form, church: e.target.value })} className="w-full px-3 py-2 border rounded" /></Field>
            <Field label="District (if applicable)"><input value={form.district} onChange={e => setForm({ ...form, district: e.target.value })} className="w-full px-3 py-2 border rounded" /></Field>
            <Field label="Department (if applicable)"><input value={form.department} onChange={e => setForm({ ...form, department: e.target.value })} className="w-full px-3 py-2 border rounded" /></Field>
          </div>
          <Field label="Photo URL (upload elsewhere first, e.g. imgur/Google Drive public link)">
            <input type="text" value={form.photo_url} onChange={e => setForm({ ...form, photo_url: e.target.value })} placeholder="https://..." className="w-full px-3 py-2 border rounded" />
          </Field>
          <Field label="Details / Bio / Notes for admin"><textarea rows="6" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} className="w-full px-3 py-2 border rounded" /></Field>
          <button type="submit" data-testid="submit-form-btn" className="btn-royal w-full justify-center"><UserPlus className="w-4 h-4" /> Submit for Review</button>
        </form>
      </section>
    </div>
  );
}
function Field({ label, children }) {
  return (<div><div className="text-sm font-semibold text-royal mb-1">{label}</div>{children}</div>);
}
